import Clevercast from "./Clevercast";

const fillInClevercastContainers = () => {
  const clevercastContainers = document.querySelectorAll(
    "[data-clevercast-video]"
  );
  [...clevercastContainers].forEach(async (clevercastContainer) => {
    new Clevercast(clevercastContainer);
  });
};

const initClevercastContainers = () => {
  fillInClevercastContainers();
};

(() => {
  const video = document.querySelector(".video");

  if (video) {
    initClevercastContainers();
  }
})();

export { initClevercastContainers };
